// Add the public gallery to Enterprise's menu and Globo's replacement.
(function () {
  if (!document.querySelector('script[data-customer-trucks-navigation]')) return;
  let scheduled = false;
  const marker = 'data-customer-trucks-menu-item';
  const directLink = item => item.querySelector(':scope > a, :scope > details > summary > a');
  function update() {
    scheduled = false;
    const english = (document.documentElement.lang || '').toLowerCase().startsWith('en');
    const label = english ? 'Customer Trucks' : 'Camions de clients';
    const href = (english ? '/en' : '') + '/pages/customer-trucks';
    document.querySelectorAll('ul.main-nav, ul.gm-menu').forEach(menu => {
      const children = Array.from(menu.children);
      const about = children.find(item => /^(À propos|About(?: us)?)$/i.test(directLink(item)?.textContent.trim() || ''));
      if (!about) return;
      const matches = children.filter(item => {
        if (item.hasAttribute(marker)) return true;
        try {
          const url = new URL(directLink(item)?.getAttribute('href'), location.origin);
          return url.origin === location.origin && /^\/(?:en\/)?pages\/customer-trucks\/?$/.test(url.pathname);
        } catch (_) { return false; }
      });
      const item = matches[0] || document.createElement('li');
      item.setAttribute(marker, '');
      // Copy only presentation classes, never Globo item IDs or event handlers.
      item.className = menu.classList.contains('gm-menu') ? 'gm-item gm-level-0' : '';
      let link = directLink(item);
      if (!link) { link = document.createElement('a'); item.appendChild(link); }
      link.className = directLink(about).className;
      link.setAttribute('data-freeland-customer-trucks-link', '');
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      if (link.getAttribute('title') !== label) link.setAttribute('title', label);
      if (link.textContent !== label) link.textContent = label;
      for (const duplicate of matches.slice(1)) duplicate.remove();
      const anchor = children.find(child => child.hasAttribute('data-dealer-map-menu-item')) || about;
      if (item.nextElementSibling !== anchor) menu.insertBefore(item, anchor);
    });
  }
  function start() {
    update();
    new MutationObserver(records => {
      if (scheduled || !records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1))) return;
      scheduled = true;
      requestAnimationFrame(update);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());

